<template>
  <modal
    :name="$lang.messages.inviteCoparentModal"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
  >
		<form
      name="inviteCoparentForm"
      class="fp-modal"
      novalidate
      @submit.prevent
      autocomplete="off"
    >
      <modals-header
        :modalNameProp="$lang.messages.invite + ' ' + coparent.firstName + ' ' + coparent.lastName"
        @hideModalProp="hideInviteCoparentModal"
      >
      </modals-header>

      <hr class="v--modal-hr">

      <input autocomplete="false" name="hidden" type="text" class="hidden">

      <!-- EMAIL -->
			<div class="part">
				<p class="label input-filter-label">
					{{ $lang.messages.email }}
					<span class="asterix">*</span>
				</p>
				<div class="input-wrapper input-field" :class="{'error-input' : errors.has('inviteCoparent.email')}">
					<input
						type="email"
						name="email"
						class="input"
            :placeholder="$lang.messages.enterCoparentEmail"
						v-model="coparent.email"
						data-vv-scope="inviteCoparent"
						v-validate="'required|min:1|max:64'"
						autocomplete="no"
            @focus.self="clearInputErrors"
            @blur="clearOthers"
          />
					<img src="@/assets/images/validation_ico.png" alt="" class="icon error-icon" />
					<div
            v-show="errors.has('inviteCoparent.email')"
            class="error-tooltip"
            :class="{'hide-tooltip' : bluredProp !== 'email'}"
          >
						<div class="text">
							{{ errors.first('inviteCoparent.email') }}
						</div>
					</div>
				</div>
			</div>


			<div class="part">
        <p class="label input-filter-label">
          <span class="asterix">*</span>
          {{ $lang.messages.mandatoryFields }}
				</p>
			</div>

      <!-- CLOSE MODAL -->
			<button
        type="button"
        class="generic-btn"
        @click="hideInviteCoparentModal"
      >
        {{ $lang.messages.back }}
      </button>

      <!-- SUBMIT -->
			<button
        class="action-btn"
        @click="onInviteCoparentFormSubmitted"
      >
        <span v-show="!loading">{{ $lang.messages.invite }}</span>
				<ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
      </button>

		</form>
	</modal>
</template>

<script>
import { mapActions } from "vuex";
import { SEND_INVITITATION_COPARENT } from "@/store/action.types";
import Autocomplete from "@/components/common/Autocomplete";
import modalsHeader from "@/components/common/modals/ModalsHeader";
import ClipLoader from 'vue-spinner/src/ClipLoader';
import Datepicker from 'vuejs-datepicker';
import STATUS_CODES from "@/common/statusCodes";

export default {
  name: "inviteCoparent",
  inject: ['$validator'],
  components: {
    Autocomplete,
    Datepicker,
		ClipLoader,
    'modals-header': modalsHeader
  },
  data() {
    return {
      coparent: {
        email: "",
        firstName: "",
        lastName: "",
				invitedCoparentGuid: ""
      },
      bluredProp: '',
			loading: false,
    };
  },
  methods: {
    ...mapActions({
      sendInvitationCoparentAction: SEND_INVITITATION_COPARENT
    }),
    show(item) {
      this.errors.clear();
      this.clearInviteCoparentData();
      this.coparent.email = item.email
			this.coparent.firstName = item.firstName
			this.coparent.lastName = item.lastName
			this.coparent.invitedCoparentGuid = item.guid
			this.$modal.show(this.$lang.messages.inviteCoparentModal)
    },
    hideInviteCoparentModal() {
      this.checkAnyInput();
      this.$modal.hide(this.$lang.messages.inviteCoparentModal);
    },
    clearInviteCoparentData() {
      this.coparent.email = ''
      this.coparent.firstName = ''
      this.coparent.lastName = ''
      this.$validator.reset()
      this.checkAnyInput()
    },
    onInviteCoparentFormSubmitted() {
      if (!this.loading) {
				this.$validator.validateAll('inviteCoparent').then(result => {
					this.checkAnyInput();
					if (result) {
						this.loading = true;
						this.sendInvitationCoparent()
					}
				});
			}
    },
		sendInvitationCoparent() {
			this.sendInvitationCoparentAction({
				email: this.coparent.email,
				invitedCoparentGuid: this.coparent.invitedCoparentGuid,
			})
			.then(() => {
				this.loading = false;
				this.hideInviteCoparentModal();
				this.loadUserProfile();
				this.$snotify.success(this.$lang.messages.sn_successCoparentInvited, "SUCCESS");
			})
			.catch(error => {
				this.loading = false;
				this.hideInviteCoparentModal()
				if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
					this.$snotify.error(error.response.data.status.desc, "ERROR")
				}
			});
		},
    loadUserProfile() {
      this.$emit("loadUserProfile");
    },
    clearInputErrors(e) {
      this.$validator.errors.remove('inviteCoparent.' + e.target.name)
    },
    checkAnyInput() {
      this.bluredProp = ''
    },
    clearOthers(e) {
      this.bluredProp = e.target.name;
      if (!e.target.value || e.target.name === "") {
        this.$validator.errors.add({
          field: this.bluredProp,
          scope: 'inviteCoparent',
          msg: `${this.$lang.messages.vee_the} ${this.$lang.messages.email} ${this.$lang.messages.vee_requiredField}.`
        })
      }
    }
  },
};
</script>
